// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__G6MMq","overlay":"Modal_overlay__Y9zUr","close":"Modal_close__ihnGo","icon":"Modal_icon__+rxnb"};